/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from 'react'
import { createUseStyles } from 'react-jss'
import classNames from 'classnames'
import style from './style'

const useStyles = createUseStyles(style)

const Fieldset = ({
  title,
  children,
  className,
  name,
}) => {
  const classes = useStyles()
  const [visible, setVisible] = useState(true)

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [className]: true,
        [classes.visible]: visible,
      })}
      name={name}
    >
      <div className={classes.arrow} onClick={() => setVisible(!visible)} />
      <h4 className={classes.title}>{title}</h4>
      <div className={classes.group}>
        {children}
      </div>
    </div>
  )
}

export default Fieldset
